import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import WholePortionAnnexBAssociatedMoistureContentSection from './WholePortionAnnexBAssociatedMoistureContentSection';
import WholePortionAnnexBPreparationMultiTraySection from './WholePortionAnnexBPreparationMultiTraySection';
import WholePortionAnnexBPreparationSingleTraySection from './WholePortionAnnexBPreparationSingleTraySection';

let WholePortionAnnexBPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const singleTray = useSelector(
    pipe(createWorksheetSelector!('Masses.MassMeasurement.WetMassMeasurements'), (p) => p?.length < 2)
  );

  return (
    <>
      {singleTray ? (
        <WholePortionAnnexBPreparationSingleTraySection />
      ) : (
        <WholePortionAnnexBPreparationMultiTraySection />
      )}
      <WholePortionAnnexBAssociatedMoistureContentSection />
    </>
  );
};

WholePortionAnnexBPreparationSection = withInjectedProps(WholePortionAnnexBPreparationSection);

export { WholePortionAnnexBPreparationSection };
export default WholePortionAnnexBPreparationSection;
